import { handleActions } from 'redux-actions';
import { sum } from 'lodash-es';

import { FurnitureValue, FurnitureFilterCount } from 'ha/types/SearchFilters';

import { FurnitureFilterState } from './Types';
import { Actions } from '../constants';

const initialState = {
  listingCount: {},
  value: [],
  isHidden: false,
};

interface Payload {
  filtersCount: {
    furniture: FurnitureFilterCount;
  };
  globalFiltersCount: {
    furniture: FurnitureFilterCount;
  };
  furniture: FurnitureValue;
}

export default handleActions<FurnitureFilterState, Payload>(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      listingCount: payload.filtersCount.furniture,
      isHidden: sum(Object.values(payload.globalFiltersCount.furniture)) === 0,
    }),
    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      { payload: { furniture = [] } },
    ) => ({
      ...state,
      value: Array.isArray(furniture) ? furniture : [furniture],
    }),
  },
  initialState,
);

export const getFurnitureFilter = (state: FurnitureFilterState) => state.value;
